import React from 'react';
import PageLayout from '../../components/common/PageLayout';
import SupplierInventoryContainer from '../blocks/SupplierInventoryContainer';

function SupplierInventoryPageContainer(props) {
  return (
    <PageLayout>
      <div className="top">
        <SupplierInventoryContainer />
      </div>
    </PageLayout>
  );
}

export default SupplierInventoryPageContainer;
